module.exports = __webpack_public_path__ + "static/img/fullScreen1.0ce6083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/fullScreen1.png
// module id = hALu
// module chunks = 0